import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
import { createContext, useState } from "react";
import { useAmplitude } from "@crehana/analytics";
import { useMe } from "@crehana/auth";
import { useTranslation } from "@crehana/i18n";
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Snackbar } from "@crehana/ui";
import { AMPLITUDE_ACTION_EVENT_NAMES, SAVED_COURSES_TRANSLATION_KEY } from "./constants";
import useDeleteCourse from "./hooks/useDeleteCourse";
import useSavedCourse from "./hooks/useSavedCourse";
import LOCALES from "./i18n";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var SavedCoursesContext = /*#__PURE__*/createContext(undefined);
var SavedCoursesProvider = function SavedCoursesProvider(_ref) {
  var _ref$isDark = _ref.isDark,
    isDark = _ref$isDark === void 0 ? false : _ref$isDark,
    children = _ref.children;
  var _useAmplitude = useAmplitude(),
    logEvent = _useAmplitude.logEvent;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = useState({
      open: false,
      message: '',
      type: 'success'
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    snackbarData = _useState4[0],
    setSnackbarData = _useState4[1];
  var _useTranslation = useTranslation(SAVED_COURSES_TRANSLATION_KEY),
    t = _useTranslation.t,
    addResourceBundle = _useTranslation.addResourceBundle;
  var _useSavedCourse = useSavedCourse(),
    saveCourseHook = _useSavedCourse.saveCourse;
  var _useDeleteCourse = useDeleteCourse(),
    deleteCourseHook = _useDeleteCourse.deleteCourse;
  addResourceBundle(LOCALES);
  var _useMe = useMe(),
    me = _useMe.me;

  /** @private */
  var getCommonAmplitudeData = function getCommonAmplitudeData(args) {
    return {
      'Course ID': args.courseId,
      'Course Name': args.courseName,
      Category: args.category,
      Subcategory: args.subcategory,
      Source: args.source,
      'Source Detail': args.sourceDetail
    };
  };

  /** @private */
  var openSnackbar = function openSnackbar(msg) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'success';
    setSnackbarData({
      message: msg,
      open: true,
      type: type
    });
  };

  /** @private */
  var handleErrorResponse = function handleErrorResponse(reason, actionType) {
    openSnackbar(actionType === 'save' ? t('SC_ERROR_SAVE_COURSE') : t('SC_ERROR_DELETE_COURSE'), 'error');
    throw new Error(reason);
  };

  /** @private */
  var closeSnackbar = function closeSnackbar() {
    return setSnackbarData(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        open: false
      });
    });
  };

  /** @public */
  var isEnabledSaveCourses = !!(me !== null && me !== void 0 && me.isPremium);

  /** @public */
  var saveCourse = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(courseId, args) {
      var _args, promiseResult, response, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _args = _objectSpread({
              launchAmplitudeEvent: true,
              showSnackbar: true
            }, args);
            setLoading(true);
            promiseResult = saveCourseHook(courseId);
            _context.p = 1;
            _context.n = 2;
            return promiseResult;
          case 2:
            response = _context.v;
            if (_args.showSnackbar) {
              openSnackbar(t('SC_BOOKMARK_ADDED_COURSE'));
            }
            if (_args.launchAmplitudeEvent) {
              logEvent({
                event: AMPLITUDE_ACTION_EVENT_NAMES.COURSE_SAVED,
                data: getCommonAmplitudeData(_objectSpread({
                  courseId: courseId
                }, _args.amplitudeData))
              });
            }
            return _context.a(2, response);
          case 3:
            _context.p = 3;
            _t = _context.v;
            return _context.a(2, handleErrorResponse(_t, 'save'));
          case 4:
            _context.p = 4;
            setLoading(false);
            return _context.f(4);
          case 5:
            return _context.a(2);
        }
      }, _callee, null, [[1, 3, 4, 5]]);
    }));
    return function saveCourse(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  /** @public */
  var deleteCourse = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(courseId, args) {
      var _args, promiseResult, response, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            _args = _objectSpread({
              launchAmplitudeEvent: true,
              showSnackbar: true
            }, args);
            setLoading(true);
            promiseResult = deleteCourseHook(courseId);
            _context2.p = 1;
            _context2.n = 2;
            return promiseResult;
          case 2:
            response = _context2.v;
            if (_args.showSnackbar) {
              openSnackbar(t('SC_BOOKMARK_REMOVED_COURSE'));
            }
            if (_args.launchAmplitudeEvent) {
              logEvent({
                event: AMPLITUDE_ACTION_EVENT_NAMES.REMOVE_COURSE,
                data: getCommonAmplitudeData(_objectSpread({
                  courseId: courseId
                }, _args.amplitudeData))
              });
            }
            return _context2.a(2, response);
          case 3:
            _context2.p = 3;
            _t2 = _context2.v;
            return _context2.a(2, handleErrorResponse(_t2, 'delete'));
          case 4:
            _context2.p = 4;
            setLoading(false);
            return _context2.f(4);
          case 5:
            return _context2.a(2);
        }
      }, _callee2, null, [[1, 3, 4, 5]]);
    }));
    return function deleteCourse(_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();

  /** @public */
  var toggleBookmarkSelection = function toggleBookmarkSelection(isSavedCourse, courseId, args) {
    return isSavedCourse ? deleteCourse(courseId, args) : saveCourse(courseId, args);
  };
  var providerValue = {
    saveCourse: saveCourse,
    deleteCourse: deleteCourse,
    toggleBookmarkSelection: toggleBookmarkSelection,
    isEnabledSaveCourses: isEnabledSaveCourses,
    loading: loading
  };
  var snackbar = process.env.NODE_ENV === 'test' ? undefined : /*#__PURE__*/_jsx(Snackbar, {
    open: snackbarData.open,
    position: "top-right",
    state: snackbarData.type === 'error' ? 'alert' : 'success',
    dismissOnDelay: 3000,
    onDismiss: closeSnackbar,
    isDark: isDark,
    message: snackbarData.message,
    dismissOnClickOutside: true
  });
  return /*#__PURE__*/_jsxs(SavedCoursesContext.Provider, {
    value: providerValue,
    children: [children, snackbar]
  });
};
export default SavedCoursesProvider;